import warningIconBlue from '@perpay-web/fintech/assets/images/warningIconBlue.svg';
import { paths } from '@perpay-web/fintech/props/appPaths';

import styles from './ErrorBoundary.scss';

export const ErrorScreen = ({ error }: { error: Error }) => (
    <div className={styles['default-error-boundary']}>
        <div className={styles['focus-layout']}>
            <div className={styles['focus-content']}>
                <div className={styles['image-container']}>
                    <img src={warningIconBlue} alt='Error' />
                </div>
                <div className={styles['header-stack']}>
                    <div className={styles.header}>Something went wrong</div>
                    <div className={styles.copy}>
                        We’ve run into an unexpected issue. Please try again
                        later, or contact our support team for assistance.
                    </div>
                </div>
                {!window.PRODUCTION ? (
                    <>
                        <p>{error.message}</p>
                        <pre className={styles['error-stack']}>
                            {error.stack}
                        </pre>
                    </>
                ) : null}
            </div>

            <div className={styles['footer-container']}>
                <a
                    className={styles['footer-button']}
                    href={paths.dashboard.path}
                >
                    Back to dashboard
                </a>
            </div>
        </div>
    </div>
);
